import { create } from 'zustand'
import type { UseBonusProps } from './types'

import {
  getBonus,
  editBonus,
  reverseWorkflowBonus,
  approvalWorkflowBonus,
  reversePreviewBonus,
  releasePreviewBonus
} from './provider'

export const useBonus = create<UseBonusProps>((set) => ({
  bonusData: null,
  setBonusData: (data) => set({ bonusData: data }),

  isBonusLoading: false,
  setIsBonusLoading: (value) => set({ isBonusLoading: value }),

  isEditBonusLoading: false,
  setIsEditBonusLoading: (value) => set({ isEditBonusLoading: value }),

  isReverseWorkflowBonusLoading: false,
  setIsReverseWorkflowBonusLoading: (value) => set({ isReverseWorkflowBonusLoading: value }),

  isApprovalWorkflowBonusLoading: false,
  setIsApprovalWorkflowBonusLoading: (value) => set({ isApprovalWorkflowBonusLoading: value }),

  isReversePreviewBonusLoading: false,
  setIsReversePreviewBonusLoading: (value) => set({ isReversePreviewBonusLoading: value }),

  isReleasePreviewBonusLoading: false,
  setIsReleasePreviewBonusLoading: (value) => set({ isReleasePreviewBonusLoading: value }),

  getBonus,
  editBonus,
  reverseWorkflowBonus,
  approvalWorkflowBonus,
  reversePreviewBonus,
  releasePreviewBonus
}))
